import dayjs from 'dayjs'
import Vue from 'vue'
import { SERVER_DATE_TIME_FORMAT } from '@/components/desk/utils'
import { localeDateFormat, localeTimeFormat } from '@/utils/Helpers'

Vue.filter('appDateTime', function(value) {
  if (value) {
    return dayjs(String(value), SERVER_DATE_TIME_FORMAT).format(`${localeDateFormat()} ${localeTimeFormat()}`)
  }
})
